import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import GlobalChatbot from "@/components/chat/GlobalChatbot";
import { CalendlyController } from "@/components/ui/calendly-controller";
import { initCriticalPreloads } from "@/utils/preloader";
import { CookieBanner } from "@/components/tracking/CookieBanner";
import { useTracking } from "@/utils/tracking";
import { InstallPWA } from "@/components/InstallPWA";
import { TrustpilotWidget } from "@/components/ui/TrustpilotWidget";
import { AppProviders } from "@/components/AppProviders";
import { AppRoutes } from "@/routes";

// ===== HELPER COMPONENTS =====

function CalendlyAssetsLoader() {
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://assets.calendly.com/assets/external/widget.css";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.head.removeChild(link);
      document.body.removeChild(script);
    };
  }, []);
  return null;
}

function ConditionalChatbot() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin') || location.pathname.startsWith('/enterprise');
  if (isAdminPage) return null;
  return <GlobalChatbot />;
}

function ConditionalCalendlyController() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin') || location.pathname.startsWith('/enterprise');
  if (isAdminPage) return null;
  return <CalendlyController />;
}

function ConditionalTrustpilotWidget() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin') || location.pathname.startsWith('/enterprise');
  if (isAdminPage) return null;
  return <TrustpilotWidget />;
}

// ===== APP CONTENT =====

function AppContent() {
  useTracking();

  useEffect(() => {
    initCriticalPreloads();
  }, []);

  return (
    <>
      <CalendlyAssetsLoader />
      <AppRoutes />
      <ConditionalChatbot />
      <ConditionalCalendlyController />
      <ConditionalTrustpilotWidget />
      <CookieBanner />
      <InstallPWA />
    </>
  );
}

// ===== MAIN APP =====

function App() {
  return (
    <AppProviders>
      <AppContent />
    </AppProviders>
  );
}

export default App;
